import React, { Component } from 'react'
import {Button} from 'react-bootstrap'
import apiAddress from '../../utils/APIEndPointAddress'
import {MdAddAPhoto} from '../Common/ReactIcons/icons'
import './Layout/ImageUploader.css'

class ImageUploader extends Component {
  constructor (props) {
    super(props)

    if (window.__BROWSER_ENV__) {
      /* Bastards cage! these break nodejs if be imported like the others above */
      ImageUploader.FineUploaderTraditional = require('fine-uploader-wrappers').default
      ImageUploader.Dropzone = require('react-fine-uploader/dropzone').default
      ImageUploader.FileInput = require('react-fine-uploader/file-input').default
      ImageUploader.ProgressBar = require('react-fine-uploader/progress-bar').default
      ImageUploader.CancelButton = require('react-fine-uploader/cancel-button').default
      ImageUploader.Thumbnail = require('react-fine-uploader/thumbnail').default
    }

    const uploader = new ImageUploader.FineUploaderTraditional({
      options: {
        request: {
          inputName: 'file',
          endPoint: `${apiAddress}horse/add-photo`
        },
        cors: {
          expected: true
        },
        deleteFile: {
          enabled: true
        },
        autoUpload: false
      }
    })

    this.state = {
      id: null,
      isEmpty: true,
      uploader: uploader,
      progress: false
    }
  }

  componentDidMount () {
    this.state.uploader.on('submitted', id => {
      this.setState({id: id, isEmpty: false, progress: false})
      this.state.uploader.methods.setName(id, 'file')
    })
    this.state.uploader.on('progress', (id) => {
      this.setState({id: id, progress: true})
    })
  }

  render () {
    const {isEmpty, id, uploader, progress} = this.state
    const reset = () => {
      uploader.methods.clearStoredFiles()
      this.setState({uploader: uploader, isEmpty: true, progress: false})
    }
    return (
      <div>
        <ImageUploader.Dropzone multiple={false} style={{width: '100%', height: '100%'}} uploader={uploader}>
          {isEmpty && <span className="doorbin"><MdAddAPhoto /></span>}
          {!isEmpty && <ImageUploader.Thumbnail id={this.state.id} uploader={uploader} maxSize={200} />}
          <div style={{display: ''}}>عکس اسب مورد نظر را اینجا بکشید و رها کنید</div>
          {isEmpty && <ImageUploader.FileInput accept="image/*" uploader={uploader}>
            <Button bsStyle="primary" bsSize="small">انتخاب از سیستم</Button>
          </ImageUploader.FileInput>}
          {progress && <ImageUploader.CancelButton id={id} uploader={uploader} onClick={reset} >بی خیال</ImageUploader.CancelButton>}
          <br />
          {!isEmpty && <Button bsStyle="danger" bsSize="small" onClick={reset}>ریست</Button>}
          <ImageUploader.ProgressBar uploader={uploader} />
        </ImageUploader.Dropzone>
      </div>
    )
  }
}

export default ImageUploader



// WEBPACK FOOTER //
// ./src/components/HorseInfo/ImageUploader.js